import React from 'react';
import './ssi-page.styles.scss';
import { Footer } from '../../../components/essentials/footer/footer.component';
import { Getstarted } from '../../../components/essentials/get-started/getstarted.component';
import { OverlapBox } from '../../../components/essentials/overlap-box/overlap-box.component';
import { NavBar } from '../../../components/essentials/navbar/navbar.component';
import ssi from '../../../assest/SSI.png';
import kysBulletPoint from '../../../assest/2 - Solutions - Platforms/secure-payment.svg';
import TrackedSection from '../../../components/essentials/google/GoogleAnalytics';
import { useTranslation } from 'react-i18next';

const DIDPage = () => {
  const { t } = useTranslation('did');

  const identitySectionsBeforeImage = t('identitySectionsBeforeImage', { returnObjects: true });
  const identitySectionsAfterImage = t('identitySectionsAfterImage', { returnObjects: true });

  return (
    <div className='ssi-platform'>
      <NavBar />
      <HeaderHalf title={t('ssiHeader')} uris={t('ssiSubHeader')} />
      <OverlapBox title={t('overlapTitle')} className='overlap-box'>
        <TrackedSection sectionName='DIDPage Definition'>
          <div>
            <div className='ssi-block'>
              <p className='ssi-text'>{t('introPara')}</p>

              {identitySectionsBeforeImage.map((section, index) => (
                <KYSCard
                  key={index}
                  icon={kysBulletPoint}
                  title={section.title}
                  desc={section.desc}
                />
              ))}

              <div className='image-ssi-container'>
                <h3
                  style={{
                    textAlign: 'center',
                    margin: '15px',
                    color: '#007bff',
                    fontWeight: 'bold',
                  }}
                >
                  {t('imageHeading')}
                </h3>
                <img src={ssi} className='img-for-ssi' alt='ssi-img' />
              </div>

              {identitySectionsAfterImage.map((section, index) => (
                <KYSCard
                  key={index}
                  icon={kysBulletPoint}
                  title={section.title}
                  desc={section.desc}
                />
              ))}

              <p className='ssi-text'>{t('postImagePara1')}</p>
              <p className='small-text'>
                <b>{t('postImagePara2')}</b>
              </p>
            </div>
          </div>
        </TrackedSection>
      </OverlapBox>
      <Getstarted />
      <Footer />
    </div>
  );
};

const HeaderHalf = ({ title, uris }) => {
  return (
    <div className='headerHalf-main-ssi'>
      <div className='headerHalf-content'>
        <p className='headerHalf-title'>{title}</p>
        <p className='headerHalf-uris'>
          Solutions / <span className='uris-class'>{uris}</span>
        </p>
      </div>
    </div>
  );
};

const KYSCard = ({ icon, desc, title }) => {
  return (
    <div className='kys-card'>
      <div>
        <img src={icon} className='kdt-card-icon' alt='kysCardIcon' />
      </div>
      <div className='key-text-col'>
        <p className='kys-card-title'>{title}</p>
        <p className='kdt-card-desc' dangerouslySetInnerHTML={{ __html: desc }} />
      </div>
    </div>
  );
};

export default DIDPage;
